let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hlerE")).then(() => parcelRequire('dz4k2'));